module.exports = __webpack_public_path__ + "media/src/images/mails/ea4e44-27a7033e4f9ea85e6227c9933b80f533.png";